export const randomString = () => (Math.random() + 1).toString(36).substring(7);
/**
 * Capitalizes the first character of each sentence. Only letters at sentence
 * boundaries are changed; other characters are left unchanged.
 * Sentence boundaries are the start of the string and positions after . ? !
 */
export const sentenceCase = (str) => str.replace(/(^|[.!?]\s*)(.)/g, (_, prefix, char) => prefix + (/[a-zA-Z]/.test(char) ? char.toUpperCase() : char));
export const friendlyCaseString = (str) => str
    .split(/(?<![A-Z])(?=[A-Z])/)
    .join(' ')
    .replace(/^\w/, str.charAt(0).toLocaleUpperCase());
export const removeNonWord = (str) => str.replace(/\W/g, '');
export const normalizeLineBreaks = (str) => str.split('\r\n').join('\n');
export function formatArrayAsStringList(value, options = { type: 'conjunction' }) {
    if ('ListFormat' in Intl) {
        const formatter = new Intl.ListFormat('en', {
            style: 'long',
            ...options,
        });
        return formatter.format(value);
    }
    const cloned = [...value];
    const last = cloned.pop();
    return `${cloned.join(', ')}, ${options.type === 'disjunction' ? 'or' : 'and'} ${last}`;
}
/**
 * Formats list of items as full string using Oxford comma.
 * @param items List of items to create list from
 * @returns
 */
export const oxfordList = (items) => {
    if (items.length === 0)
        return undefined;
    if (items.length === 1)
        return items[0];
    if (items.length === 2)
        return `${items[0]} and ${items[1]}`;
    const [...rest] = items;
    const last = rest.pop();
    return `${rest.join(', ')}, and ${last}`;
};
export const makeFilenameVeriskSafe = (input) => input.replace(/[\\/&?%*|:\\\\<>"]/g, '_');
export const digitsOnly = (value) => `${value}`.replace(/\D/g, '');
const alreadyPlural = new Set(['media']);
export function pluralize(noun, count, ending = 's') {
    if (alreadyPlural.has(noun.toLowerCase()))
        return noun;
    return `${noun}${count === 1 ? '' : ending}`;
}
/**
 * decodeURIComponent that returns the input unchanged instead of throwing on
 * malformed percent-encoding (stored meta is not guaranteed well-formed).
 */
export function safeDecodeURIComponent(value) {
    try {
        return decodeURIComponent(value);
    }
    catch {
        return value;
    }
}
